import React,{useState,useEffect} from 'react'
import { useAuth } from '../../context/AuthContext'
import { Link, NavLink, useNavigate } from 'react-router-dom'
import { AccountCircle, Announcement, BookOnline, CalendarMonthOutlined, Campaign, Chat, Dashboard, Devices, DoorSliding, Dvr, FollowTheSigns, Home,  Label,  ListAlt,  ManageAccounts, MoreVert, Newspaper, NoteAlt, Notifications, PhoneAndroid, Settings, SmartToy, Store, Tablet, TransferWithinAStation, Tv, WorkOutlined} from '@mui/icons-material';
import useBusinessInfo from '../../hooks/useBusinessInfo';
import { Alert } from '@mui/material';
import moment from 'moment';

function AdminHeader() {

    const {authUser } = useAuth();
   

    return (
        <>
        
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top shadow mb-3">
            <div className="container-fluid">
                <Link className="me-2" to="/"><img src='/images/megamind.png' style={{height:40}} /></Link> {/* navbar-brand  */}
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="collapsibleNavbar">
                    { authUser.role <= 2 && 
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0" style={{fontSize:"18px"}}>
                        <li className="nav-item"><NavLink className="nav-link text-center" to="/"> <Home/> Home</NavLink></li>
                        <li className="nav-item"><NavLink className="nav-link text-center" to="/task/dashboard"> <Dashboard/> Task Board </NavLink></li>
                        <li className="nav-item"><NavLink className="nav-link text-center" to="/device/dashboard"> <Devices/> Devices </NavLink></li>
                        <li className="nav-item"><NavLink className="nav-link text-center" to="/notes/dashboard"> <NoteAlt /> Notes </NavLink></li>
                        <li className="nav-item"><NavLink className="nav-link text-center" to="/megamind/assistant"> <SmartToy /> Megamind </NavLink></li>
                        {/*<li className="nav-item"><NavLink className="nav-link text-center" to="/megamind/bot"> <SmartToy /> Megamind </NavLink></li> */}
                        {/* Dropdown ref 
                        <li className="nav-item dropdown">
                            <NavLink className="nav-link dropdown-toggle" to="/report" role="button" data-bs-toggle="dropdown"><ListAlt/>Report</NavLink>
                            <ul className="dropdown-menu">
                                <li><NavLink className="dropdown-item" to="/report/token-report">Token Report</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/report/feedback-report">Feedback Report</NavLink></li>
                            </ul>
                        </li>
                        */}
                        
                    </ul>
                    }
                    {/* Just for Alignment  */}
                    { authUser.role > 2 &&
                        <div className=" me-auto "></div>
                    } 

                        <ul className="navbar-nav">
                            { authUser.role == 1 && 
                            <li className="nav-item dropdown">
                                <a className="nav-link" href="!#" id="adminControllDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false"> <MoreVert/> </a>
                                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="adminControllDropdown">
                                    <li><NavLink className="dropdown-item" to="/master/list"><Label /> Status Master</NavLink></li>
                                    <li><NavLink className="dropdown-item" to="/business/details"><WorkOutlined/> Business Details</NavLink></li>
                                    <li><NavLink className="dropdown-item" to="/user/list"><ManageAccounts/> Manage User Accounts</NavLink></li>
                                    <li><NavLink className="dropdown-item" to="/user/role"><Settings/> Manage User Role</NavLink></li>
                                </ul>
                            </li>
                            }



                            <li className="nav-item dropdown">
                                <a className="btn btn-info" style={{borderRadius:"50px"}} href="!#" id="userDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false"> 
                                    {authUser.firstName.charAt(0).toUpperCase()}
                                </a>
                                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
                                    {/*<li><a className="dropdown-item" href="/auth/change-password">Change Password</a></li> */}
                                    <li><hr className="dropdown-divider"/></li>
                                    <li><NavLink className="dropdown-item" to="/auth/logout">Logout</NavLink></li>
                                </ul>
                            </li>
                        </ul>
                </div>
            </div>
        </nav>
        </>
    )
}

export default AdminHeader